import { render, staticRenderFns } from "./serviceinfoListCheckOrg.vue?vue&type=template&id=2fb62e1c&scoped=true&"
import script from "./serviceinfoListCheckOrg.vue?vue&type=script&lang=js&"
export * from "./serviceinfoListCheckOrg.vue?vue&type=script&lang=js&"
import style0 from "./serviceinfoListCheckOrg.vue?vue&type=style&index=0&id=2fb62e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb62e1c",
  null
  
)

export default component.exports